/**
 * oauth2 token class for auvious' services.
 */
export class OAuth2Token {
    get isExpired() {
        return this.expiresAt.getTime() < new Date().getTime();
    }
    constructor(client, json) {
        this._client = client;
        if (json) {
            this.importJSON(json);
        }
    }
    importJSON(json) {
        if (!json) {
            throw new Error("Json arg is null. Pass a valid json(can be stringified or object) " +
                "any into the first argument.");
        }
        if (typeof json === "string") {
            try {
                json = JSON.parse(json);
            }
            catch (e) {
                throw new Error("Failed to parse stringified json." +
                    " Pass a valid json(can be stringified) " +
                    "any into the first argument.");
            }
        }
        // server side
        this.type = json.token_type;
        this.accessToken = json.access_token;
        this.refreshToken = json.refresh_token;
        this.scope = json.scope;
        this.isGuest = json.isGuest;
        this.userId = this.getValueFromJwtToken(this.accessToken, "sub");
        // client side
        this.createdAt = json.createdAt ? new Date(json.createdAt) : new Date();
        const exp = this.getValueFromJwtToken(this.accessToken, "exp");
        this.expiresAt = exp
            ? new Date(exp * 1000)
            : new Date(Date.now() + 365 * 24 * 60 * 60 * 1000); // if no exp, consider it expired after a year
        this.expiresIn = json.expires_in;
    }
    toJSON() {
        return {
            // server side
            token_type: this.type,
            access_token: this.accessToken,
            refresh_token: this.refreshToken,
            isGuest: this.isGuest,
            scope: this.scope,
            userId: this.userId,
            // client side
            createdAt: this.createdAt.toJSON(),
            expiresAt: this.expiresAt.toJSON(),
            isExpired: this.isExpired,
        };
    }
    toJSONStringified() {
        return JSON.stringify(this.toJSON());
    }
    get bearer() {
        return "Bearer " + this.accessToken;
    }
    refresh() {
        return this._client.refreshToken(this);
    }
    getValueFromJwtToken(token, field) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        return JSON.parse(window.atob(base64))[field];
    }
}
